import * as angular from 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

export class LocalStorageService {
    set(key, value) {
        localStorage.setItem(key, value);
    }

    read(key) {
        return localStorage.getItem(key);
    }

    delete(key) {
        localStorage.removeItem(key);
    }

    saveObject(key, item) {
        localStorage.setItem(key, JSON.stringify(item));
    }

    getObject(key) {
        return JSON.parse(localStorage.getItem(key));
    }

    removeLocalData() {
        this.delete('common/token');
        this.delete('common/user');
        this.delete('common/company');
    }

    getCompanyEmployee() {
        return this.getObject('common/company');
    }
}

angular
    .module('app')
    .factory('LocalStorageService', downgradeInjectable(LocalStorageService));



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/local_storage.service.ts